import { IconType } from 'react-icons';
import { AiOutlineQuestion } from 'react-icons/ai';
import {
  MdAssessment, MdAssignment, MdBuild, MdExtension, MdInfo, MdMonetizationOn, MdPeople, MdSettingsInputComponent,
} from 'react-icons/md';
import { action, makeObservable, observable } from 'mobx';
import { Category } from '../../constants';
import { t } from '../../stores/TranslateStore';

export default class MenuModel {
  readonly id: string;

  readonly iconType?: string;

  readonly text?: string;

  readonly path?: string;

  readonly level?: string;

  readonly category?: number;

  @observable isEnabled?: boolean; // Open/Close

  parent: MenuModel | undefined;

  children?: MenuModel[];

  view?: React.Component;

  constructor(
    id: string,
    icon: string,
    text?: string,
    path?: string,
    level?: string,
    category?: number,
    isEnabled?: boolean,
    parent?: MenuModel,
    children?: MenuModel[],
    view?: React.Component,
  ) {
    this.id = id;
    this.iconType = icon;
    this.text = text || '##';
    this.path = path || '/';
    this.level = level || '1';
    this.category = category ?? Category.COMMON;
    this.isEnabled = isEnabled || false;
    this.parent = parent;
    this.children = children || [];
    this.view = view || undefined;

    makeObservable(this);
  }

  @action
  enable(value: boolean) {
    this.isEnabled = value;
  }

  get icon(): IconType {
    switch (this.iconType) {
      case 'AiOutlineQuestion':
        return AiOutlineQuestion;
      case 'MdAssessment':
        return MdAssessment;
      case 'MdAssignment':
        return MdAssignment;
      case 'MdBuild':
        return MdBuild;
      case 'MdExtension':
        return MdExtension;
      case 'MdInfo':
        return MdInfo;
      case 'MdMonetizationOn':
        return MdMonetizationOn;
      case 'MdPeople':
        return MdPeople;
      case 'MdSettingsInputComponent':
        return MdSettingsInputComponent;
    }
    return AiOutlineQuestion;
  }

  // 표시 전용 번역 메뉴명. text(원문 한국어)는 검색·경로·비교 로직이 그대로
  // 쓰므로 건드리지 않고, 화면에 그릴 때만 이 값을 쓴다. t.T 는 관측 가능한
  // 사전을 읽으므로, 이 게터를 render 에서 읽는 컴포넌트가 observer 이면
  // 번역이 도착했을 때 자동으로 다시 그려진다.
  get textT(): string {
    return t.T(this.text ?? '');
  }
}
